var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApiGenerateSampleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8897_43373)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 4.99888H3.39C4.03667 4.00504 4.98721 3.2468 6.09991 2.83717C7.21261 2.42754 8.4279 2.38847 9.56462 2.72577C10.7013 3.06308 11.6986 3.7587 12.4078 4.70894C13.117 5.65919 13.5001 6.81317 13.5 7.99888H14.5C14.5014 6.66162 14.0903 5.35649 13.3227 4.26143C12.5552 3.16638 11.4686 2.33471 10.2111 1.87982C8.95358 1.42492 7.58637 1.36896 6.29589 1.71955C5.00541 2.07014 3.85447 2.81022 3 3.83888V1.99888H2V5.99888H6V4.99888Z",
    fill: "#49A3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 11H12.61C11.9633 11.9938 11.0128 12.7521 9.90009 13.1617C8.78739 13.5713 7.5721 13.6104 6.43539 13.2731C5.29867 12.9358 4.30139 12.2402 3.59221 11.2899C2.88303 10.3397 2.49993 9.18571 2.5 8H1.5C1.49863 9.33726 1.90973 10.6424 2.67727 11.7374C3.4448 12.8325 4.53141 13.6642 5.78892 14.1191C7.04642 14.574 8.41363 14.6299 9.70411 14.2793C10.9946 13.9287 12.1455 13.1887 13 12.16V14H14V10H10V11Z",
    fill: "#49A3FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8897_43373"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiGenerateSampleIcon);
export default __webpack_public_path__ + "static/media/APIGenerateSampleIcon.ce14c12c0079494c0c603767e1f351cf.svg";
export { ForwardRef as ReactComponent };